import axios from 'axios';
import { getAdminToken } from './auth';

const resolvedBaseUrl =
  process.env.REACT_APP_API_BASE_URL || 'https://adminofallapss.oxmite.com';
  // 'http://localhost:5940';

/** Base URL used for all admin API calls (no trailing slash). */
export function getApiBaseUrl() {
  return resolvedBaseUrl.replace(/\/$/, '');
}

const api = axios.create({
  baseURL: getApiBaseUrl(),
});

api.interceptors.request.use((config) => {
  const token = typeof window !== 'undefined' ? getAdminToken() : null;
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const method = (error?.config?.method || 'request').toUpperCase();
    const url = `${error?.config?.baseURL || ''}${error?.config?.url || ''}`;
    const status = error?.response?.status || 'NO_RESPONSE';
    console.error(`[api] ${method} ${url} failed with status ${status}`, {
      message: error?.message,
      serverMessage: error?.response?.data?.message,
    });
    return Promise.reject(error);
  }
);

export default api;
